import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import Sidebar from "../../DesignSystem/Sidebar";
import { db } from "../../../backend/firebaseConfig";
import "../../../css/Adviser/AuditLogsPage.css";
import { ReactComponent as BackIcon } from "../../../assets/icons/Back.svg";
import { formatAuditField, formatAuditFieldShort } from "./auditHelpers";

const formatDateTime = (value) => {
  if (!value) return "-";

  let d = null;

  if (value?.seconds != null) {
    d = new Date(value.seconds * 1000);
  } else if (value instanceof Date) {
    d = value;
  } else if (typeof value === "string" || typeof value === "number") {
    d = new Date(value);
  }

  if (!d || Number.isNaN(d.getTime())) return "-";

  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const stringifyValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

const matchesFilter = (value, filter) => {
  if (!filter) return true;
  return String(value || "")
    .toLowerCase()
    .includes(filter.toLowerCase());
};

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  const [entityFilter, setEntityFilter] = useState("");
  const [entityIdFilter, setEntityIdFilter] = useState("");
  const [changedByFilter, setChangedByFilter] = useState("");
  const [sectionFilter, setSectionFilter] = useState("");
  const [fieldFilter, setFieldFilter] = useState("");

  useEffect(() => {
    const logsRef = collection(db, "AuditLogs");
    const logsQuery = query(logsRef, orderBy("changedAt", "desc"), limit(300));

    const unsub = onSnapshot(
      logsQuery,
      (snap) => {
        const next = snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        setLogs(next);
        setLoading(false);
      },
      (error) => {
        console.error("Failed to load audit logs:", error);
        setLogs([]);
        setLoading(false);
      },
    );

    return unsub;
  }, []);

  const filteredLogs = useMemo(() => {
    return logs.filter((log) => {
      return (
        matchesFilter(log.entity, entityFilter) &&
        matchesFilter(log.entityId, entityIdFilter) &&
        matchesFilter(log.changedBy, changedByFilter) &&
        matchesFilter(log.section, sectionFilter) &&
        matchesFilter(log.field, fieldFilter)
      );
    });
  }, [
    logs,
    entityFilter,
    entityIdFilter,
    changedByFilter,
    sectionFilter,
    fieldFilter,
  ]);

  return (
    <div className="main-content">
      <Helmet>
        <title>Audit Logs</title>
      </Helmet>

      <Sidebar />

      <div className="Main-Container">
        <div className="auditLogsPage">
          <div className="auditLogsHeader">
            <h3 className="FP_Content_h3">
              <BackIcon
                className="backIcon"
                onClick={() => window.history.back()}
              />
              Edit Logs
            </h3>
            {/* <div>
              <div className="FP_Content-Semibold">
                View who changed what and when.
              </div>
            </div> */}
          </div>

          {/* <div className="auditLogsFiltersCard">
            <div className="auditLogsFiltersGrid">
              <div className="auditFilterField">
                <label>Entity</label>
                <input
                  value={entityFilter}
                  onChange={(e) => setEntityFilter(e.target.value)}
                  placeholder="e.g. adviser"
                />
              </div>

              <div className="auditFilterField">
                <label>Entity ID</label>
                <input
                  value={entityIdFilter}
                  onChange={(e) => setEntityIdFilter(e.target.value)}
                  placeholder="e.g. adviser email/id"
                />
              </div>

              <div className="auditFilterField">
                <label>Changed by</label>
                <input
                  value={changedByFilter}
                  onChange={(e) => setChangedByFilter(e.target.value)}
                  placeholder="e.g. staff@..."
                />
              </div>

              <div className="auditFilterField">
                <label>Section</label>
                <input
                  value={sectionFilter}
                  onChange={(e) => setSectionFilter(e.target.value)}
                  placeholder="e.g. personalDetails"
                />
              </div>

              <div className="auditFilterField auditFilterFieldWide">
                <label>Field</label>
                <input
                  value={fieldFilter}
                  onChange={(e) => setFieldFilter(e.target.value)}
                  placeholder="e.g. personalDetails.forename"
                />
              </div>
            </div>
          </div> */}

          <div className="auditLogsTableCard">
            {loading ? (
              <div className="auditLogsEmpty">Loading audit logs...</div>
            ) : filteredLogs.length === 0 ? (
              <div className="auditLogsEmpty">No audit logs found.</div>
            ) : (
              <div className="auditLogsList">
                {filteredLogs.map((log) => {
                  const expanded = expandedId === log.id;

                  return (
                    <div key={log.id} className="auditLogRow">
                      <div className="auditLogTop">
                        <div className="auditLogMain">
                          {/* <div className="auditLogField">
                            {log.field || "-"}
                          </div> */}
                          <div className="auditLogField">{log.entityId}</div>
                          <div className="auditLogMeta">
                            {/* <span>{log.entity || "-"}</span>
                            <span>•</span> */}
                            <span>
                              {formatAuditFieldShort(log.field) || "-"}
                            </span>
                            <span>•</span>
                            <span>{log.changedBy || "unknown"}</span>
                            <span>•</span>
                            <span>{formatDateTime(log.changedAt)}</span>
                          </div>
                        </div>

                        {/* <button
                          className="auditExpandBtn"
                          onClick={() =>
                            setExpandedId((prev) =>
                              prev === log.id ? null : log.id,
                            )
                          }
                        >
                          {expanded ? "Hide" : "View"}
                        </button> */}
                      </div>

                      <div className="auditLogPreview">
                        <div className="auditChangeBox">
                          <div className="auditChangeLabel">Old</div>
                          <div className="auditChangeValue">
                            {stringifyValue(log.oldValue)}
                          </div>
                        </div>

                        <div className="auditChangeArrow">→</div>

                        <div className="auditChangeBox">
                          <div className="auditChangeLabel">New</div>
                          <div className="auditChangeValue">
                            {stringifyValue(log.newValue)}
                          </div>
                        </div>
                      </div>

                      {expanded ? (
                        <div className="auditLogExpanded">
                          <div className="auditExpandedGrid">
                            <div>
                              <div className="auditExpandedLabel">Section</div>
                              <div className="auditExpandedValue">
                                {log.section || "-"}
                              </div>
                            </div>

                            <div>
                              <div className="auditExpandedLabel">Page</div>
                              <div className="auditExpandedValue">
                                {log.page || "-"}
                              </div>
                            </div>

                            <div>
                              <div className="auditExpandedLabel">
                                Changed by UID
                              </div>
                              <div className="auditExpandedValue">
                                {log.changedByUid || "-"}
                              </div>
                            </div>

                            <div>
                              <div className="auditExpandedLabel">Log ID</div>
                              <div className="auditExpandedValue">{log.id}</div>
                            </div>
                          </div>

                          <div className="auditRawGrid">
                            <div className="auditRawBlock">
                              <div className="auditExpandedLabel">
                                Old value
                              </div>
                              <pre>{stringifyValue(log.oldValue)}</pre>
                            </div>

                            <div className="auditRawBlock">
                              <div className="auditExpandedLabel">
                                New value
                              </div>
                              <pre>{stringifyValue(log.newValue)}</pre>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
